import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';

// Prefer same-origin /datasets/... so webpack-dev-server proxy and nginx both work
// when the server returns absolute http(s) dataset URLs.
export const normalizeDatasetImageSrc = src => {
	if (!src || typeof src !== 'string') return src;
	try {
		const url = new URL(src, window.location.origin);
		if (url.pathname.startsWith('/datasets/')) {
			return `${url.pathname}${url.search}`;
		}
	} catch (e) {
		// keep original
	}
	return src;
};

const PhotoStrip = ({ images, setModalImageId, setAnImageLoaded }) => {
	let imageItems = [];
	for (const imageId in images) {
		const imageSrc = normalizeDatasetImageSrc(images[imageId]);
		imageItems.push(
			<div key={imageId} className="photoStripImage">
				<Image
					src={imageSrc}
					thumbnail
					responsive
					onClick={() => { setModalImageId(imageId); }}
					onLoad={imageItems.length ? null : setAnImageLoaded} />
			</div>
		);
	}
	if (imageItems.length === 0) {
		imageItems = (<div><i>No images.</i></div>);
	}
	return (
		<div className="photoStrip">
			{imageItems}
		</div>
	);
};

PhotoStrip.propTypes = {
	images: PropTypes.object,
	setModalImageId: PropTypes.func,
	setAnImageLoaded: PropTypes.func
};

export default PhotoStrip;
